export default __webpack_public_path__ + "images/keep_practicing_illustration.c02b133099acea4e54f48e7c885ceed0.svg";